export default __webpack_public_path__ + "static/media/logo_black.8ed696dd.svg";